import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { useValidate } from "formvalidation/hooks";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  onChanged: (newSortCode: string) => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  validatorKey: string
}

const SortCodeInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    return /\d{2}-\d{2}-\d{2}/.test(input) && input.length === serverReference.constants.bankAccount.maxSortCodeLength;
  };

  const validate = async (input: string) => {
    const isValid = isValidInput(input);
    return isValid;
  };

  const formatInput = (input: string, e?) => {
    if (isValidInput(input)) {
      e?.preventDefault();
      props.onChanged(input);
      return input;
    }

    const digits = input.trim().replace(/\D/g, "");
    if (digits.length === serverReference.constants.bankAccount.exactSortCodeLength) {
      e?.preventDefault();
      const formatted = digits.substring(0, 2) + "-" + digits.substring(2, 4) + "-" + digits.substring(4);
      props.onChanged(formatted);

      return formatted;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    formatInput(props.value);
  };

  const onChange = (_, { value }) => {
    props.onChanged(value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.BankAccount.SortCode,
    value: props.value,
    validate: validate,
    ref: semanticRef.ref
  })

  return <Input
    ref={semanticRef.refSetter}
    value={props.value}
    onChange={onChange}
    maxLength={serverReference.constants.bankAccount.maxSortCodeLength}
    onPaste={onPaste}
    error={validation.error.hasError}
    onBlur={onBlur}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    placeholder="00-00-00"
    fluid
  />;
};

export default SortCodeInput;